const singleton = (key, supplier) => {
  if (!window.singletons[key]) {
    window.singletons[key] = supplier();
  }
  return window.singletons[key];
};
const singletonActions = (key, supplier) => singleton(`${key}Actions`, supplier);
const singletonStore = (key, supplier) => singleton(`${key}Store`, supplier);
if (typeof window.singletons === "undefined") {
  window.singletons = {};
}
export { singleton, singletonActions, singletonStore };
